import EntryActionTypes from '../constants/EntryActionTypes';

const fetchCardPointAdvancedDataInCurrentCard = () => ({
  type: EntryActionTypes.CARD_POINT_ADVANCED_DATA_IN_CURRENT_CARD_FETCH,
});

const createCardPointAdvancedDataInCurrentCard = () => ({
  type: EntryActionTypes.CARD_POINT_ADVANCED_DATA_IN_CURRENT_CARD_CREATE,
});

const updateCardPointAdvancedData = (id, data) => ({
  type: EntryActionTypes.CARD_POINT_ADVANCED_DATA_UPDATE,
  payload: {
    id,
    data,
  },
});

const deleteCardPointAdvancedData = (id) => ({
  type: EntryActionTypes.CARD_POINT_ADVANCED_DATA_DELETE,
  payload: {
    id,
  },
});

export default {
  fetchCardPointAdvancedDataInCurrentCard,
  createCardPointAdvancedDataInCurrentCard,
  updateCardPointAdvancedData,
  deleteCardPointAdvancedData,
};

